<mat-drawer-container class="dashboard-item-drawer-container" [hasBackdrop]="true" autosize>
  <mat-drawer
    class="item-details-drawer"
    mode="over"
    position="end"
    [autoFocus]="false"
    [opened]="!!selectedTileItem"
    (closedStart)="closeTileItemDrawer()"
  >
    <div class="item-details-drawer-content">
      <div class="item-details-drawer-header">
        <div class="item-details-drawer-title">
          <ng-container
            *ngIf="
              selectedTileItemTitleLoading && selectedTileItemHasProjectNameProperty !== false;
              else resolvedDrawerTitle
            "
          >
            <span class="item-details-title-skeleton" aria-hidden="true"></span>
          </ng-container>
          <ng-template #resolvedDrawerTitle>
            {{
              selectedTileItemTitle ||
                (selectedTileItemHasProjectNameProperty === false ? 'itemdetails' : '')
            }}
          </ng-template>
        </div>
        <button mat-icon-button (click)="closeTileItemDrawer()" aria-label="Close item drawer">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <ng-container *ngIf="selectedTileItem as selectedTileItemData">
        <suvo-bi-data-source-item-view
          [alias]="selectedTileItemData.alias"
          [itemId]="selectedTileItemData.itemId"
          (itemTitleResolved)="onTileItemTitleResolved($event)"
          (itemNamePropertyConfigured)="onItemNamePropertyConfigured($event)"
        />
      </ng-container>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <mat-sidenav-container autosize>
      <mat-sidenav
        #filtersSidenav
        class="right-sidenav"
        [mode]="filtersSidenavMode"
        autoFocus="false"
        fixedInViewport="true"
        position="end"
        [opened]="filtersSidenavOpenedByDefault"
        *ngIf="!hideRightHandFilters && filtersChannel"
      >
        <suvo-bi-filters-sidenav
          [filtersChannel]="filtersChannel"
          [exportDisabled]="exportDisabled"
        ></suvo-bi-filters-sidenav>
      </mat-sidenav>

      <mat-sidenav-content class="middle-page standard-padding">
        <app-customer-header>
          <suvo-bi-dashboard-breadcrumbs
            headerLeft
            [links]="breadcrumbs"
          ></suvo-bi-dashboard-breadcrumbs>
          <div headerRight class="top-right-buttons-anchor">
            <div class="d-flex fd-row jc-end ai-center">
              <app-email-alerts-button
                *ngIf="filterGroup"
                [filterGroup]="filterGroup"
              ></app-email-alerts-button>
              <suvo-bi-active-filters-widget
                class="filters-widget"
                *ngIf="!hideRightHandFilters && filtersChannel"
                [filtersChannel]="filtersChannel"
              ></suvo-bi-active-filters-widget>
            </div>
          </div>
        </app-customer-header>

        <div
          class="dashboard-padding dashboard-container standard-padding"
          [class.no-padding]="!dashboard?.displayProperties?.padding"
        >
          <suvo-bi-dashboard
            *ngIf="dashboard?.canView && !forceUnmount; else noDashboard"
            [dashboard]="dashboard"
            [settings]="dashboardSettings"
            [filtersChannel]="filtersChannel"
            [isCreation]="isCreation"
          ></suvo-bi-dashboard>

          <suvo-bi-dashboard-no-subscription
            [dataSource]="dataSource"
            *ngIf="!dashboard?.canView"
          ></suvo-bi-dashboard-no-subscription>

          <ng-template #noDashboard>
            <div
              *ngIf="!showErrorMessage; else errorMessage"
              class="loading d-flex fd-col ai-stretch"
            >
              <suvo-bi-skeleton-grid />
            </div>
            <ng-template #errorMessage>
              <suvo-core-error-message title="Something went wrong" [message]="showErrorMessage" />
            </ng-template>
          </ng-template>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-drawer-content>
</mat-drawer-container>
